module.exports = __webpack_public_path__ + "img/Saint Lucia.69951689.svg";